import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, List, Paper, Chip, Tooltip } from '@mui/material';
import helpIntroduction from '../../components/help/assets/HelpIntroduction.png';
import help21 from '../../components/help/assets/Help21.png';
import help22 from '../../components/help/assets/Help22.png';
import help23 from '../../components/help/assets/Help23.png';
import help31 from '../../components/help/assets/Help31.png';
import help32 from '../../components/help/assets/Help32.png';
import help33 from '../../components/help/assets/Help33.png';
import help34 from '../../components/help/assets/Help34.png';
import help35 from '../../components/help/assets/Help35.png';
import help41 from '../../components/help/assets/Help41.png';
import help42 from '../../components/help/assets/Help42.png';
import help43 from '../../components/help/assets/Help43.png';
import help51 from '../../components/help/assets/Help51.png';
import help52 from '../../components/help/assets/Help52.png';
import help53 from '../../components/help/assets/Help53.png';
import help54 from '../../components/help/assets/Help54.png';
import help61 from '../../components/help/assets/Help61.png';
import help62 from '../../components/help/assets/Help62.png';
import help63 from '../../components/help/assets/Help63.png';
import help64 from '../../components/help/assets/Help64.png';
import { useTranslation } from 'react-i18next';

type Section = {
    id: number;
    title: string;
    content: (string | { type: 'text' | 'image', value: string })[];
};

const sections: Section[] = [
    {
        id: 0,
        title: 'TITLE_SECTION_1',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_1' },
            { type: 'image', value: helpIntroduction },
            { type: 'text', value: 'CONTENT_2_SECTION_1' }
        ],
    },
    {
        id: 1,
        title: 'TITLE_SECTION_2',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_2' },
            { type: 'text', value: 'CONTENT_2_SECTION_2' },
            { type: 'image', value: help21 },
            { type: 'text', value: 'CONTENT_3_SECTION_2' },
            { type: 'image', value: help22 },
            { type: 'text', value: 'CONTENT_4_SECTION_2' },
            { type: 'text', value: 'CONTENT_5_SECTION_2' },
            { type: 'text', value: 'CONTENT_6_SECTION_2' },
            { type: 'text', value: 'CONTENT_7_SECTION_2' },
            { type: 'text', value: 'CONTENT_8_SECTION_2' },
            { type: 'image', value: help23 }
        ],
    },
    {
        id: 2,
        title: 'TITLE_SECTION_3',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_3' },
            { type: 'image', value: help31 },
            { type: 'text', value: 'CONTENT_2_SECTION_3' },
            { type: 'text', value: 'CONTENT_3_SECTION_3' },
            { type: 'text', value: 'CONTENT_4_SECTION_3' },
            { type: 'image', value: help32 },
            { type: 'text', value: 'CONTENT_5_SECTION_3' },
            { type: 'image', value: help33 },
            { type: 'text', value: 'CONTENT_6_SECTION_3' },
            { type: 'text', value: 'CONTENT_7_SECTION_3' },
            { type: 'text', value: 'CONTENT_8_SECTION_3' },
            { type: 'text', value: 'CONTENT_9_SECTION_3' },
            { type: 'text', value: 'CONTENT_10_SECTION_3' },
            { type: 'image', value: help34 },
            { type: 'text', value: 'CONTENT_11_SECTION_3' },
            { type: 'image', value: help35 }
        ],
    },
    {
        id: 3,
        title: 'TITLE_SECTION_4',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_4' },
            { type: 'image', value: help41 },
            { type: 'image', value: help42 },
            { type: 'text', value: 'CONTENT_2_SECTION_4' },
            { type: 'text', value: 'CONTENT_3_SECTION_4' },
            { type: 'image', value: help43 }
        ],
    },
    {
        id: 4,
        title: 'TITLE_SECTION_5',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_5' },
            { type: 'image', value: help51 },
            { type: 'image', value: help52 },
            { type: 'text', value: 'CONTENT_2_SECTION_5' },
            { type: 'text', value: 'CONTENT_3_SECTION_5' },
            { type: 'image', value: help53 },
            { type: 'text', value: 'CONTENT_4_SECTION_5' },
            { type: 'text', value: 'CONTENT_5_SECTION_5' },
            { type: 'image', value: help54 }
        ],
    },
    {
        id: 5,
        title: 'TITLE_SECTION_6',
        content: [
            { type: 'text', value: 'CONTENT_1_SECTION_6' },
            { type: 'text', value: 'CONTENT_2_SECTION_6' },
            { type: 'image', value: help61 },
            { type: 'text', value: 'CONTENT_3_SECTION_6' },
            { type: 'image', value: help62 },
            { type: 'text', value: 'CONTENT_4_SECTION_6' },
            { type: 'text', value: 'CONTENT_5_SECTION_6' },
            { type: 'image', value: help63 },
            { type: 'text', value: 'CONTENT_6_SECTION_6' },
            { type: 'image', value: help64 }
        ],
    }
];

const Help: React.FC = () => {
    const { t } = useTranslation();
    const { sectionId } = useParams<{ sectionId?: string }>();
    const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

    const scrollToSectionWithOffset = (index: number) => {
        const element = sectionRefs.current[index];
        if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        if (sectionId) {
            const sectionIndex = Number(sectionId) - 1;
            setTimeout(() => {
                scrollToSectionWithOffset(sectionIndex);
            }, 100);
        }
    }, [sectionId]);

    const handleScrollToSection = (index: number) => {
        scrollToSectionWithOffset(index);
    };

    return (
        <Box sx={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
            <List sx={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                {sections.map((section, index) => (
                    <Chip
                        key={section.id}
                        label={t(`${section.title}`)}
                        onClick={() => handleScrollToSection(index)}
                        sx={{ padding: '10px', fontSize: '16px', cursor: 'pointer' }}
                        clickable
                        className='button-color'
                    />
                ))}
            </List>
            <br />
            {sections.map((section, index) => (
                <Paper
                    key={section.id}
                    ref={(el) => (sectionRefs.current[index] = el)}
                    elevation={3}
                    sx={{ padding: '30px', marginBottom: '40px', borderRadius: '10px', backgroundColor: '#f8f9fa' }}
                >
                    <Typography variant="h5" component="h2" sx={{ marginBottom: '15px', color: '#333' }}>
                        {t(`${section.title}`)}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {section.content.map((contentItem, idx) => (
                            <Box key={idx}>
                                {typeof contentItem === 'string' ? (
                                    <Typography sx={{ fontSize: '16px', lineHeight: '1.6', color: '#555' }} paragraph>
                                        {t(`${contentItem}`)}
                                    </Typography>
                                ) : contentItem.type === 'text' ? (
                                    <Typography sx={{ fontSize: '16px', lineHeight: '1.6', color: '#555' }} paragraph>
                                        {t(`${contentItem.value}`)}
                                    </Typography>
                                ) : (
                                    <Tooltip title={t(`CLICK_TO_OPEN_IMAGE_IN_NEW_TAB`)}>
                                        <a href={contentItem.value} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={contentItem.value}
                                                alt={`Section ${section.id}`}
                                                style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                                            />
                                        </a>
                                    </Tooltip>
                                )}
                            </Box>
                        ))}
                    </Box>
                </Paper>
            ))}
        </Box>
    );
};

export default Help;